import React from "react";

/**
 * Reusable editor-window chrome: traffic lights, a filename tab and an
 * optional right-hand slot. Wraps any content in a consistent "IDE pane".
 */
const Window = ({ file, icon, right, className = "", barClassName = "", children }) => (
  <div className={`win ${className}`}>
    <div className={`win-bar ${barClassName}`}>
      <span className="dots">
        <span className="bg-light-red" />
        <span className="bg-light-amber" />
        <span className="bg-light-green" />
      </span>
      <span className="flex items-center gap-2 truncate">
        {icon}
        <span className="truncate text-syntax-comment">{file}</span>
      </span>
      {right && <span className="ml-auto flex items-center gap-3">{right}</span>}
    </div>
    {children}
  </div>
);

export default Window;
